import React, { useState } from 'react';
import { imageUrl } from '../config';
import { useBlock } from './SiteContent';

const DEFAULT = {
  title: 'Обо мне',
  paragraphs: [
    'Меня зовут Светлана. Я психолог и КПТ-практик. Знаю вашу боль не из учебников, а из собственного опыта. Именно поэтому я работаю не с позиции «я училась», а с позиции «я там была».',
    'Мой подход — это сплав строгой научной базы и глубокого человеческого чувствования. Я не верю в пустые советы, «позитивное мышление» и волшебные таблетки. Я верю в честность с самим собой, практическую работу и человечность — в то, что приносит реальные изменения.',
    'Когнитивно-поведенческая терапия помогает перепрограммировать автоматические мысли. НЛП и телесные практики — снять зажимы и вернуть ощущение безопасности в теле. А честный разговор, без масок и «надо», позволяет услышать себя.',
    'Я прошла этот путь изнутри. И я точно знаю: выход есть.',
  ],
};

export default function About() {
  const a = useBlock('about', DEFAULT);
  const paragraphs = a.paragraphs?.length ? a.paragraphs : DEFAULT.paragraphs;
  const [loaded, setLoaded] = useState(false);
  return (
    <section id="about" className="py-16 md:py-24 bg-oat" data-testid="about">
      <div className="max-w-6xl mx-auto px-5 md:px-8 grid md:grid-cols-12 gap-10 md:gap-14 items-start">
        <div className="reveal md:col-span-5">
          <div className="relative aspect-[4/5] overflow-hidden bg-cream">
            <img
              src={imageUrl('about_office')}
              alt="Кабинет Светланы Белавской"
              loading="lazy"
              onLoad={() => setLoaded(true)}
              className={`w-full h-full object-cover transition-opacity duration-700 ${loaded ? 'opacity-100' : 'opacity-0'}`}
              data-testid="about-img"
            />
          </div>
        </div>

        <div className="reveal md:col-span-7">
          <div className="flex items-center gap-3 mb-4 text-[12px] tracking-[0.24em] uppercase text-wine/70">
            <span className="gold-divider" />
            <span data-testid="about-eyebrow">{(a.title || DEFAULT.title).toLowerCase()}</span>
          </div>

          <h2 className="font-heading text-3xl md:text-[44px] leading-tight text-ink mb-7" data-testid="about-heading">
            Я знаю эту дорогу,<br />потому что прошла её&nbsp;сама.
          </h2>

          <div className="space-y-4 text-[15.5px] md:text-base leading-relaxed text-ink/80" data-testid="about-paragraphs">
            {paragraphs.map((p, i) => (
              <p key={i} data-testid={`about-paragraph-${i}`}>{p}</p>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
